export default function FullPageCenterItems({ fullscreen, height, children }) {
    return (
        <div
            style={{
                display: "grid",
                width: fullscreen ? `95vw` : `100%`,
                height: fullscreen ? `95vh` : height ?? `100%`,
                placeItems: "center",
                // backgroundColor: "red"
            }}>
            <div style={{ display: "grid", placeItems: "center" }}>
                {children}
            </div>
        </div>
    )

}
